const hasVideoInputDevice = require('../../src/js/client/hasVideoInputDevice')
  .default;

exports._hasVideoInputDevice = hasVideoInputDevice;
